import { ContentChildren, Directive, ElementRef, HostListener, Input, QueryList } from '@angular/core';
import { APP_RESIZE_HANDLE, ResizeHandleDirective } from './resizeHandle.directive';
import { APP_RESIZABLE_PARENT } from './resizable-parent';

@Directive({
  selector: '[appResizable]',
  host: {
        'class': 'app-resizable',
        '[class.app-resizable-resizing]': 'resizing',
    },
    providers: [{
            provide: APP_RESIZABLE_PARENT,
            useExisting: ResizableDirective
        }],
  standalone: false
})
export class ResizableDirective {
  @Input() minWidth: number | string = 0;
  @Input() maxWidth: number | string = 9999;

  @Input() minHeight: number | string = 0;
  @Input() maxHeight: number | string = 9999;

  @Input() widthProps = ['width'];
  @Input() heightProps = ['height'];

  @ContentChildren(APP_RESIZE_HANDLE, { descendants: true })
  _handles: QueryList<ResizeHandleDirective>;

  resizing = false;

  constructor(public element: ElementRef<HTMLElement>) { }

  beginResize() {
    document.body.classList.add('appResizable__resizing');

    this.resizing = true;
  }

  resize(dx: number, dy: number) {
    this.updateProperties(dx, dy);
  }

  endResize() {
    this.resizing = false;

    document.body.classList.remove('appResizable__resizing');
  }

  private updateProperties(dx: number, dy: number) {
    if (dx != 0) {
      let width = this.element.nativeElement.offsetWidth;
      let newWidth = Math.min(Math.max(width + dx, Number(this.minWidth)), Number(this.maxWidth));
      let wstyle = `${newWidth}px`;

      for (let prop of this.widthProps) {
        this.element.nativeElement.style.setProperty(prop, wstyle);
      }
    }

    if (dy != 0) {
      let height = this.element.nativeElement.offsetHeight;
      let newHeight = Math.min(Math.max(height + dy, Number(this.minHeight)), Number(this.maxHeight));
      let hstyle = `${newHeight}px`;

      for (let prop of this.heightProps) {
        this.element.nativeElement.style.setProperty(prop, hstyle);
      }
    }
  }
};
